import script from "./Admin-Datahubv2.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin-Datahubv2.vue?vue&type=script&setup=true&lang=js"

import "./Admin-Datahubv2.vue?vue&type=style&index=0&id=7d973066&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d973066"]])

export default __exports__